import React, { useState } from "react";
import { Grid, Typography, Stack, Box, Container } from "@mui/material";
import "./index.css";
import CustomButton from "../generic-components/Button/Button";
import { useNavigate } from "react-router-dom";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

const Achievements = ({
  title,
  titleColor,
  secondTitle,
  secondTitleColor,
  description,
  sideImage,
  button,
  truncateWords,
}) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleNavigation = (route) => {
    if (route) {
      navigate(route);
    }
  };

  // helper to truncate text by words
  const truncateText = (text, limit) => {
    if (!limit) return text;

    const words = text.split(/\s+/);
    if (words.length <= limit) return text;

    return words.slice(0, limit).join(" ") + "...";
  };

  const paragraphs = React.useMemo(() => {
    // ✅ JSX description (truncate by paragraphs)
    if (React.isValidElement(description)) {
      const childrenArray = React.Children.toArray(description.props.children);

      if (!truncateWords || expanded) {
        return childrenArray;
      }

      // show only first paragraph when collapsed
      return [childrenArray[0]];
    }

    // ✅ String description (truncate by words)
    const fullParagraphs = description
      .split(/\r?\n\r?\n/)
      .map((p) => p.trim())
      .filter(Boolean);

    if (!truncateWords || expanded) {
      return fullParagraphs;
    }

    const joinedText = fullParagraphs.join(" ");
    return [truncateText(joinedText, truncateWords)];
  }, [description, truncateWords, expanded]);

  return (
    <Container maxWidth="xl" sx={{ my: 5 }}>
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid size={{ sm: 6, xs: 12 }}>
          <Stack spacing={2}>
            <Typography className="achievements-title-text" color={titleColor}>
              {title}

              {secondTitle && (
                <Typography
                  component="span"
                  className="achievements-title-text"
                  color={secondTitleColor}
                  sx={{ ml: 2 }}
                >
                  {secondTitle}
                </Typography>
              )}
            </Typography>

            {paragraphs.map((paragraph, idx) => (
              <Typography
                key={idx}
                component="div"
                className="achievements-description-text"
              >
                {paragraph}
              </Typography>
            ))}

            {truncateWords && (
              <Typography
                className="achievements-readmore-button"
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "Read Less" : "Read More"}
              </Typography>
            )}

            <Box
              sx={{
                mt: 0,
                alignSelf: { xs: "center", sm: "flex-start" },
              }}
            >
              {button && (
                <CustomButton
                  className={
                    button.className || "achievements-stack-button"
                  }
                  startIcon={<PermContactCalendarIcon />}
                  text={button.text || ""}
                  onClick={() =>
                    button.route
                      ? handleNavigation(button.route)
                      : button.onClick?.()
                  }
                />
              )}
            </Box>
          </Stack>
        </Grid>

        <Grid size={{ sm: 6, xs: 12 }}>
          <Box>
            <img
              src={sideImage}
              alt="Consulting"
              style={{
                width: "100%",
                borderRadius: 8,
                height: "100%",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Achievements;
